import { ACTION_TYPES, MODULE_NAME } from './constants';
import reducer from './reducer';

export {
    selectFirstMessage
} from './selectors';

export {
    emitMessage,
    dismissFirstMessage,
    clearMessages
} from './actions';

export {
    ACTION_TYPES,
    MODULE_NAME
};

export default {
    reducer,
    moduleName: MODULE_NAME
};
